import packageJson from '../../package.json'

const testid = (id: string): string => {
  const name = packageJson.name.replace(/[@]/g, '').replace(/\//g, '-')
  return `${name}__${id}`
}

export default testid
